// Pure, dependency-free category-tree search filter. Kept outside
// DropshippingCategories.js (same pattern as platformVisibility.js and
// orderPaymentUI.js) so it can be unit-tested with plain node:test without
// pulling in React/react-router-dom/react-icons through the page component.
const normalizeSearchText = (value) => String(value || "").toLowerCase();

// Filtre l'arborescence 3 niveaux par nom, à n'importe quel niveau -- si un
// niveau 1/2 correspond directement à la recherche, tous ses descendants
// restent affichés tels quels (l'utilisateur qui cherche "Electronics" veut
// voir toutes ses sous-catégories, pas seulement celles qui répètent le mot).
const filterCategoryTree = (categories, query) => {
  const q = normalizeSearchText(query).trim();
  if (!q) return categories;
  const matches = (name) => normalizeSearchText(name).includes(q);
  return categories
    .map((level1) => {
      const level1Matches = matches(level1.name);
      const children = (level1.children || [])
        .map((level2) => {
          const level2Matches = level1Matches || matches(level2.name);
          const leaves = (level2.children || []).filter((leaf) => level2Matches || matches(leaf.name));
          if (!level2Matches && !leaves.length) return null;
          return { ...level2, children: leaves };
        })
        .filter(Boolean);
      if (!level1Matches && !children.length) return null;
      return { ...level1, children };
    })
    .filter(Boolean);
};

module.exports = { filterCategoryTree };
